import axios from 'axios';

const apiv1 = axios.create({ baseURL: '/v1' });

apiv1.interceptors.request.use((config) => {
  // Token de panel (staff) o del portal (cliente).
  const token = localStorage.getItem('token')
             || localStorage.getItem('portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiv1.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiv1;
